import { selectDefaultFolder } from 'owa-mail-folder-forest-actions';
export default function mailModuleRouteHandler() {
    selectDefaultFolder();
}
//# sourceMappingURL=mailModuleRouteHandler.js.map